export default {
    state: {
        appName: "后台管理系统",  // 应用名称
        collapse:false,  // 导航栏收缩状态
        themeColor: "#1d4274",  // 主题颜色
        menuRouteLoaded:false    // 菜单和路由是否已经加载
    },
    getters: {
        collapse(state){// 对应着上面state
            return state.collapse
        }
      // menuRouteLoaded(){
      //     return sessionStorage.getItem('menuRouteLoaded')
      // }
    },
    mutations: {
        onCollapse(state){  // 改变收缩状态
            state.collapse = !state.collapse
        },
        menuRouteLoaded(state, menuRouteLoaded){  // 改变菜单和路由的加载状态
            state.menuRouteLoaded = menuRouteLoaded;
            // sessionStorage.setItem('menuRouteLoaded',JSON.parse(state.menuRouteLoaded))
        }
    },
    actions: {
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js